'use client';

import {
  AIInput,
  AIInputSubmit,
  AIInputTextarea,
} from '@ahafood/ui/components/ai/input';
import type { FormEventHandler } from 'react';

interface ChatInputProps {
  text: string;
  onTextChange: (text: string) => void;
  onSubmit: FormEventHandler<HTMLFormElement>;
  isLoading?: boolean;
  status?: 'submitted' | 'streaming' | 'ready' | 'error';
}

export function ChatInput({
  text,
  onTextChange,
  onSubmit,
  isLoading = false,
  status = 'ready',
}: ChatInputProps) {
  return (
    <div className="px-4 pb-4 pt-2">
      <AIInput
        onSubmit={onSubmit}
        className="relative shadow-md border-none rounded-xl bg-neutral-10/70 md:bg-white/40 md:backdrop-blur-md md:border md:border-white/30"
      >
        <AIInputTextarea
          className="pr-14 h-10 min-h-14 focus:min-h-20 transition-all duration-200 ease-in-out"
          placeholder="Ăn gì nào bạn ơi?"
          onChange={(e) => onTextChange(e.target.value)}
          value={text}
        />
        <AIInputSubmit
          className="absolute top-1/2 right-3 -translate-y-1/2 text-red-50 hover:text-red-60 bg-white hover:bg-neutral-10 transition-colors duration-200"
          disabled={
            !text ||
            isLoading ||
            status === 'streaming' ||
            status === 'submitted'
          }
          status={status}
        />
      </AIInput>
    </div>
  );
}
